(function () {
    let installed = false;

    const init = () => {
        if (installed) return;
        const drawer = document.querySelector("cart-drawer");
        if (!drawer) return;

        new MutationObserver(() => {
            if (drawer.hasAttribute("open")) {
                window.tlCartGoalEmbed?.renderAllCartGoals();
            }
        }).observe(drawer, { attributes: true, attributeFilter: ["open"] });

        installed = true;
    };

    setTimeout(init, 500);
})();
